<template>
  <div class="categories-block categories-line">
    <div v-if="title" class="titler">Kategori:</div>

    <ul v-if="!categories" class="category-list">
      <li class="cat dummy"></li>
      <li class="cat dummy"></li>
      <li class="cat dummy"></li>
    </ul>

    <ul
      v-else-if="resolvedCategories && resolvedCategories.length > 0"
      class="category-list"
    >
      <li class="cat " v-for="(cat, i) in resolvedCategories" :key="i">
        <router-link
          class="cat-name"
          v-if="link"
          :to="{ name: archiveName, query: { kategori: cat.id } }"
        >
          {{ cat.name }}
        </router-link>
        <span v-else class="cat-name">{{ cat.name }}</span>
        <span class="sep">,</span>
      </li>
    </ul>
  </div>
</template>

<script>
//import WpLink from "@/components/elements/WpLink";

import { mapGetters } from "vuex";

export default {
  name: "categories-block",
  props: {
    categories: Array,
    taxonomy: {
      type: String,
      default: "category"
    },
    title: {
      type: Boolean,
      default: true
    },
    link: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {};
  },
  mounted() {
    /*  if(this.categories){
            this.resolveCategories();
        } */
  },
  methods: {
    resolveCategories() {}
  },
  computed: {
    ...mapGetters(["getCategory"]),
    resolvedCategories() {
      let categories = [];
      if (this.categories) {
        this.categories.forEach(catID => {
          let c = null;
          c = this.getCategory(catID, this.taxonomy);
          if (c) categories.push(c);
        });
      }
      return categories;
    },
    archiveName() {
      let name = "archivePost";
      //console.log('aname', this.taxonomy)
      switch (this.taxonomy) {
        case "help_cat":
          name = "archiveHelp";
          break;
        case "inspir_taxonomy":
          name = "archiveInspirasjon";
          break;
        case "event_cat":
          name = "archiveEvents";
          break;
        case "video_cat":
          name = "archiveVideo";
          break;
        case "sponsors_cat":
          name = "archiveSponsors";
          break;
        case "posttypes":
          name = "archivePost";
          break;
      }
      return name;
    }
  },
  components: {
    //WpLink
  }
};
</script>

<style lang="scss">
@import "./../../assets/scss/mixins.scss";
@import "./../../assets/scss/vars.scss";
.categories-block {
  border-bottom: 2px solid $purple;
  padding-bottom: 20px;
  margin-bottom: 20px;
  margin-top: 50px;
  .titler {
    font-size: 16px;
    font-weight: 700;
    display: inline-block;
    margin-right: 5px;
  }
  .category-list {
    padding: 0;
    margin: 0;
    list-style: none;
    font-size: 16px;
    display: inline-block;
    li {
      display: inline-block;
      margin-right: 5px;
      &.dummy {
        height: 15px;
        width: 48px;
        @extend %preloadBgLight;
        &:nth-child(2) {
          width: 61px;
        }
        &:nth-child(3) {
          width: 41px;
        }
      }
      &:last-child {
        .sep {
          display: none;
        }
      }
    }
    a {
      color: inherit;
      text-decoration: none;
    }
  }
}
</style>
